module.exports = __webpack_public_path__ + "static/media/adventureHikingIcon.2afaadac.png";